import styled from "styled-components"

const NavigationOverlayFill = styled.div`
  position: absolute;
  pointer-events: ${({ active }) => (active ? "auto" : "none")};
  background: #000;
  top: 0;
  left: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
`

export default NavigationOverlayFill



// WEBPACK FOOTER //
// ./src/Kiosk/Navigator/NavigationOverlayFill.js